// src/App.js
import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from "react-router-dom";

// Tetap lazy load semua
const Home = lazy(() => import("./pages/Home"));
const Tebakpin = lazy(() => import("./components/Tebakpin"));
const Kasihtanda = lazy(() => import("./components/Kasihtanda"));
const Setara = lazy(() => import("./components/Setara"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Feedback = lazy(() => import("./components/feedback"));

function GameWrapper({ Component }) {
  const { lang } = useParams();
  const applang = (lang || "id").toUpperCase();
  return <Component applang={applang} />;
}

function HomeWrapper() {
  const { lang } = useParams();
  const applang = (lang || "id").toUpperCase();
  return <Home applang={applang} />;
}

const App = () => {
  

  return (
    <Router>
      <Suspense fallback={<div className="loading">Loading...</div>}>
        <Routes>
          <Route path="/" element={<Navigate to="/id" replace />} />
          <Route path="/tebak-pin" element={<Navigate to="/id/tebak-pin" replace />} />
          <Route path="/kasih-tanda" element={<Navigate to="/id/kasih-tanda" replace />} />
          <Route path="/setara" element={<Navigate to="/id/setara" replace />} />

          <Route path="/:lang" element={<HomeWrapper />} />
          <Route path="/:lang/tebak-pin" element={<GameWrapper Component={Tebakpin} />} />
          <Route path="/:lang/kasih-tanda" element={<GameWrapper Component={Kasihtanda} />} />
          <Route path="/:lang/setara" element={<GameWrapper Component={Setara} />} />

          <Route path="/feedback/*" element={<Feedback />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
